import { addColumn } from "./addColumn";
import { archiveBoard } from "./archiveBoard";
import { deleteBoard } from "./deleteBoard";
import { getAllAvailableBoards } from "./getAllAvailableBoards";
import { getSacramentStructures } from "./getSacramentStructures";
import { linkColumnToBoard } from "./linkColumnToBoard";
import { saveDefaultFilter } from "./saveDefaultFilter";

const mockResponses = {
  saveDefaultFilter,
  archiveBoard,
  deleteBoard,
  getAllAvailableBoards,
  linkColumnToBoard,
  getSacramentStructures,
  addColumn,
};

export default mockResponses;
